// Import and register all your controllers
import { application } from "./application"
import HelloController from "./hello_controller"
import AdminBookingFormController from "./admin_booking_form_controller"
import ReviewsCarouselController from "./reviews_carousel_controller"
import LightboxController from "./lightbox_controller"
import NavbarController from "./navbar_controller"
import PasskeyRegistrationController from "./passkey_registration_controller"
import PasskeyLoginController from "./passkey_login_controller"
import BookingCalendarController from "./booking_calendar_controller"

application.register("hello", HelloController)
application.register("admin-booking-form", AdminBookingFormController)
application.register("reviews-carousel", ReviewsCarouselController)
application.register("lightbox", LightboxController)
application.register("navbar", NavbarController)
application.register("passkey-registration", PasskeyRegistrationController)
application.register("passkey-login", PasskeyLoginController)
application.register("booking-calendar", BookingCalendarController)
